import "@/App.css";
import "@/index.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { ToastProvider } from "./context/ToastContext";
import Navbar from "./components/Navbar";
import AdminRoute from "./components/AdminRoute";

const Homepage = lazy(() => import("./pages/Homepage"));
const ShopPage = lazy(() => import("./pages/ShopPage"));
const ProductDetailPage = lazy(() => import("./pages/ProductDetailPage"));
const LoginPage = lazy(() => import("./pages/LoginPage"));
const CartPage = lazy(() => import("./pages/CartPage"));
const CheckoutPage = lazy(() => import("./pages/CheckoutPage"));
const TheBoldWayPage = lazy(() => import("./pages/TheBoldWayPage"));
const AccountPage = lazy(() => import("./pages/AccountPage"));
const LoyaltyPage = lazy(() => import("./pages/LoyaltyPage"));
const InfoPage = lazy(() => import("./pages/InfoPage"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));
const AdminProducts = lazy(() => import("./pages/admin/AdminProducts"));
const AdminOrders = lazy(() => import("./pages/admin/AdminOrders"));
const AdminReturns = lazy(() => import("./pages/admin/AdminReturns"));
const AdminUsers = lazy(() => import("./pages/admin/AdminUsers"));
const AdminNewsletter = lazy(() => import("./pages/admin/AdminNewsletter"));
const AdminCoupons = lazy(() => import("./pages/admin/AdminCoupons"));
const AdminAdvancedAnalytics = lazy(() => import("./pages/admin/AdminAdvancedAnalytics"));
const AdminSettings = lazy(() => import("./pages/admin/AdminSettings"));

function RouteFallback() {
  return (
    <div className="min-h-screen bg-black text-white pt-24 flex items-center justify-center px-6">
      <div className="text-center">
        <p className="font-anton text-4xl sm:text-5xl tracking-tight uppercase">Loading</p>
        <p className="mt-3 font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-gray-500">
          Preparing Boldway
        </p>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <CartProvider>
              <Navbar />
              <Suspense fallback={<RouteFallback />}>
                <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/product/:id" element={<ProductDetailPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/admin/login" element={<LoginPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/the-bold-way" element={<TheBoldWayPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/loyalty" element={<LoyaltyPage />} />
                <Route path="/contact-info" element={<InfoPage />} />
                <Route path="/privacy-policy" element={<InfoPage />} />
                <Route path="/refund-policy" element={<InfoPage />} />
                <Route path="/shipping-policy" element={<InfoPage />} />
                <Route path="/terms-of-service" element={<InfoPage />} />
                <Route path="/terms-and-conditions" element={<InfoPage />} />

                <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
                <Route path="/admin/products" element={<AdminRoute><AdminProducts /></AdminRoute>} />
                <Route path="/admin/orders" element={<AdminRoute><AdminOrders /></AdminRoute>} />
                <Route path="/admin/returns" element={<AdminRoute><AdminReturns /></AdminRoute>} />
                <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
                <Route path="/admin/newsletter" element={<AdminRoute><AdminNewsletter /></AdminRoute>} />
                <Route path="/admin/coupons" element={<AdminRoute><AdminCoupons /></AdminRoute>} />
                <Route path="/admin/analytics" element={<AdminRoute><AdminAdvancedAnalytics /></AdminRoute>} />
                <Route path="/admin/settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />
                </Routes>
              </Suspense>
            </CartProvider>
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
